import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const pickSoundCardGroupStyles: SxStyles = {
  pickSoundCardGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .title-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      '& .title': {
        fontFamily: theme.typography.mainFontFamily,
        alignSelf: 'center',
        fontWeight: '400',
        color: theme.palette.mainControls?.subTitleColor,
        fontSize: theme.typography.fs13,
        p: 0,
        pb: getResponsiveSize(10),
        pointerEvents: 'none',
      },
    },
    '& .items-container-tasks': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    '& .items-container-sounds': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '& .items-container': {
      display: 'grid',
      gridTemplateRows: 'repeat(2, auto)',
      gap: getResponsiveSize(10),

      '& .card': {
        position: 'relative',
        width: getResponsiveSize(49),
        borderRadius: '10px',
        backgroundColor: theme.palette.mainControls?.inActivegrey,
        '& .desc': {
          position: 'absolute',
          bottom: '7%',
          left: '50%',
          color: theme.palette.mainControls?.lightBlue,
          fontSize: getResponsiveSize(9),
          lineHeight: 1.5,
          transform: 'translateX(-50%)',
        },
        '& .icon': {
          '& svg': {
            fill: theme.palette.neutral?.grey,
            '& path': {
              fill: theme.palette.mainControls?.lightBlue,
            },
          },
        },
        '&.active': {
          backgroundColor: theme.palette.mainControls?.mainBlue,
          '& .desc': {
            color: theme.palette.neutral?.white,
          },
          '& .icon': {
            '& svg': {
              fill: theme.palette.neutral?.white,
              '& path': {
                fill: theme.palette.neutral?.white,
              },
            },
          },
          '& .MuiButtonBase-root': {
            position: 'relative',
            '&:before': {
              content: "''",
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              filter: 'blur(2px)',
              border: 'inherit',
              zIndex: '1',
            },
          },
        },
        '& .MuiButtonBase-root': {
          position: 'relative',
          display: 'flex',
          justifyContent: 'start',
          flexDirection: 'column',
          p: getResponsiveSize(20),
          height: getResponsiveSize(45.2),
          borderRadius: theme.palette.propVars?.borderRadius,
          transition: theme.palette.propVars?.easeInOutTransition,
          '& .icon': {
            position: 'absolute',
            top: '15%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: getResponsiveSize(24),
            height: getResponsiveSize(24),
          },
          '& .MuiCardContent-root': {
            p: 0,
          },
        },
      },
    },
  },
};
